/**
 * @module store/points/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив всех акций
 *
 * @returns {array}
 */
const points = state => state.points;


/**
 * Getter: Возвращает массив действующийх на текущий момент акций
 *
 * @returns {array}
 */
const activePoints = state => {
  const now = new Date();

  return state.points.filter(item => (!item.endDate || (new Date(item.endDate) >= now)));
}


/**
 * Getter: Возвращает флаг загружаются ли точки в текущий момент
 *
 * @returns {boolean}
 */
const isPointsLoading = state => state.isPointsLoading;

export default {
  activePoints,
  isPointsLoading,
  points,
};
